<div class="container-fluid">
    <div *ngIf="!coreData.IsOffline" class="row justify-content-center my-2">

        <div class="col d-flex justify-content-center">
            <mat-form-field class="col-6">
                <mat-label>Code Echantillon</mat-label>
                <input matInput placeholder="Code Echantillon" [(ngModel)]="SearchText" (keyup.enter)="searchBySampleCode()">
            </mat-form-field>
            <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="primary" (throttledClick)="searchBySampleCode()">
                Rechercher
            </button>
            <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" (throttledClick)="openCyanoCreationBox()">
                Créer une analyse Cyano<mat-icon>add</mat-icon>
            </button>
        </div>
        <div class="text-end" style="width: 200px">
            <button appPreventDoubleClick matTooltip="Tout afficher" class="m-2" mat-mini-fab color="accent" (throttledClick)="searchAnalysisList()">
                <mat-icon>reorder</mat-icon>
            </button>
            <button appPreventDoubleClick matTooltip="Afficher les analyses terminées" style="background: green;" class="m-2" mat-mini-fab (throttledClick)="searchAnalysisList(3)">
                <mat-icon>done</mat-icon>
            </button>
            <button appPreventDoubleClick matTooltip="Afficher les analyses annulées" class="m-2" mat-mini-fab color="warn" (throttledClick)="searchAnalysisList(4)">
                <mat-icon>block</mat-icon>
            </button>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-4 col-xl-2 my-2" *ngFor="let a of AnalysisList">
            <div class="h-100 m-3">
                <div class="row border rounded-1 background-light h-100" [class.clickable]="a.Code !== undefined && a.Code !== ''" [class.no-opacity]="a.Code === undefined || a.Code === ''"
                     [style.border-bottom-color]="getColorByInterventionStatus(a.Type)"
                     style="border-width: 2px !important; border-bottom: 10px solid !important;"
                     (click)="navigateToAnalysis(a)">

                    <div class="d-flex flex-column col ms-1 p-2">
                        <div class="row">
                            <h2 class="col text-center fw-bold"> {{a.ELIMSData.StationName}}</h2>
                        </div>
                        <!-- <h5 class="card-header">{{a.ELIMSData.StationCode}}</h5> -->
                        <mat-chip-list class="d-flex justify-content-center my-3">
                            <mat-chip class="fw-bold" [style.background]="getColorByInterventionStatus(a.Type)"
                                      [style.color]="getTextColorByInterventionStatus(a.Type)">{{getInterventionLabel(a)}}</mat-chip>
                            <mat-chip>{{a.PartnerCode}}</mat-chip>
                        </mat-chip-list>

                        <!-- <div class="card-body"> -->
                        <div class="row g-0">
                            <h5 class="col text-center">{{ a.SampleCode}}</h5>
                        </div>
                        <div class="row">
                            <span class="col text-center">{{a.ELIMSData.ClientName}}</span>
                        </div>

                        <div class="row">
                            <span *ngIf="!a.ValidatedByFullname" class="col text-center"> {{ getAnalysisStatusName(a.Status) }}</span>
                            <span *ngIf="a.ValidatedByFullname" class="col text-center"> Validé par {{ a.ValidatedByFullname}} </span>
                        </div>
                        <div class="row">
                            <span *ngIf="a.NombrePhase === 3" class="col text-center">Nombre de phases: {{a.NombrePhase}} </span>
                            <span *ngIf="a.NombrePhase === 12" class="col text-center">Nombre de pots: {{a.NombrePhase}} </span>
                        </div>
                        <div class="row d-flex align-items-center mt-auto g-0">
                            <span class="col"><small class="text-muted">{{a.DateRenduClient | date}}</small></span>
                        
                            <span class="col-auto">
                                <button *ngIf="!coreData.IsOffline" appPreventDoubleClick mat-icon-button (throttledClick)="navigateToNotation(a); $event.stopPropagation();">
                                    <mat-icon>note_add</mat-icon>
                                </button>
                            </span>
                        </div>
                    </div>
                    <!-- <div style="height: 5px" [style.background]="getColorByInterventionStatus(a.Type)"></div> -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</div>